import React, { useCallback } from "react";
import webui from "@tinqin/tinqin-web-ui";
import EntityBuilder from "@tinqin/tinqin-web-ui/src/utils/EntityBuilder";
import { xssFilter } from "../../../common/utils/xssFilter";
import { IComponentProps, SirenEntity } from "Common/utils/commonTypes";

type ExtractedItemProps = {
    title: string;
    text: string;
    itemClass: string; 
    buttonLabel: string;
    buttonCallback: () => void;
}

export const ColoredBoxes: React.FC<IComponentProps> = props => {
    const extractItemProps = useCallback(
        (itemData: SirenEntity, index: number): ExtractedItemProps => {
            const itemProps: Record<string, any> = itemData.properties || {};
            const title: string = itemProps.title;
            const text: string = itemProps.text;
            let itemClass: string = "tq-neutral-color-bg-4";
            if (index % 3 === 1) {
                itemClass = "tq-main-color-bg";
            } else if (index % 3 === 2) {
                itemClass = "";
            }
            const itemEntities = itemData.entities || [];
            const buttonEntity = EntityBuilder.of(itemEntities[0], { inplace: true });
            const buttonLabel = buttonEntity.getProperty("label");
            const buttonActions = buttonEntity.getActions();
            const buttonCallback = () =>
                webui.getUtils().dispatchSirenActions(props, ["default", "click"], {
                    actions: buttonActions
                });
            return { title, text, itemClass, buttonLabel, buttonCallback };
        },
        [props]
    );

    const buildChildren = useCallback(
        (entities:SirenEntity[] = []) =>
            entities.map((item: SirenEntity, index: number) => {
                const { title, text, itemClass, buttonLabel, buttonCallback } = extractItemProps(
                    item,
                    index
                );

                return (
                    <div key={index} className={`tq-flex-item ${itemClass} un-offer-flexbox`}>
                        <div className="un-offer-flexbox-content tq-text-center">
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: xssFilter.process(title)
                                }}
                                data-hyperlinks-container={true}
                            ></div>
                            <div
                                className="un-offer-flexbox-content-smallp"
                                dangerouslySetInnerHTML={{
                                    __html: xssFilter.process(text)
                                }}
                                data-hyperlinks-container={true}
                            ></div>
                            {buttonLabel && (
                                <button
                                    onClick={buttonCallback}
                                    className="tq-button tq-button-border"
                                >
                                    <span className="tq-text-node">{buttonLabel}</span>
                                </button>
                            )}
                        </div>
                    </div>
                );
            }),
        [extractItemProps]
    );

    const data: Record<string, any> = props.data ? props.data.properties || {} : null;
    if (!data) {
        return null;
    }
    return (
        <div
            className="tq-flex-container tq-flex-item-stretch tq-flex-item-l-2 tq-flex-item-m-2 tq-flex-item-s-1 un-offerboxes-container"
            id={data.anchorId ? data.anchorId : null}
        >
            {buildChildren(props.data && props.data.entities)}
        </div>
    );
};

export default webui.connectComponent({
    actions: {
        dispatchSirenActions: "siren.dispatchSirenActions"
    }
})(ColoredBoxes);
